import React, { useState, useEffect } from 'react';
import {
	Container,
	Header,
	Title,
	Text,
	Button,
	Icon,
	Footer,
	Left,
	Body,
	Right,
	ListItem,
	Content,
	Separator,
	View,
	Card,
	CardItem,
	H3,
	Tabs,
	Tab,
	Spinner,
	FooterTab,
	Label,
	Input,
	Form,
	Item,
	List
} from 'native-base';
import { Platform, StyleSheet, Dimensions } from 'react-native';
import * as DocumentPicker from 'expo-document-picker';
import * as FileSystem from 'expo-file-system';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import CalCalDataApi from '../../api/CalCalDataApi';
import Alert from '../../components/alert';

export default function Attachments({ jwt, navigation, year, close }) {
	const [attachments, setAttachments] = useState([]);
	const [error, setError] = useState(null);
	const [deleted, setDeleted] = useState(null);

	useEffect(() => {
		//pull current attachments
		CalCalDataApi.dataLoad(`sa/${year}/attachments`, jwt, res => {
			if (__DEV__) console.log(res);

			if (res.success) {
				setAttachments(res.attachments);
			} else {
				setError(res.error);
			}
		});
	}, [deleted]); //refresh when deleted changes

	const removeAttachment = id => {
		CalCalDataApi.dataDelete(`sa/${year}/attachments/${id}`, jwt, res => {
			if (res.success) setDeleted(id);
			if (!res.success) Alert.alert('Could not delete', res.message);
		});
	};

	const addAttachment = async () => {
		//On success returns a promise that resolves to an object containing { type: 'success', uri, name, size }
		const { type, uri, name, size } = await DocumentPicker.getDocumentAsync({ type: 'application/pdf', multiple: true });
		if (type != 'cancel') {
			//console.log(uri, name, size);
			//const docstr = await FileSystem.readAsStringAsync(doc.uri, { encoding: FileSystem.EncodingType.Base64 });
			try {
				const fetchResponse = await fetch(uri);
				//console.log('fetchResponse', fetchResponse);
				const file = await fetchResponse.text();
				//console.log('blob', file);
				CalCalDataApi.dataInsert(`sa/${year}/attachments`, { uri, name, size, file }, jwt, res => {
					console.log(res);
					if (res.success) setDeleted(deleted + 1); //yeh I know, just refresh
				});
			} catch (error) {
				console.log('ERR: ' + error.message);
			}
		}
	};

	return (
		<Container style={{ backgroundColor: '#FFF' }}>
			<Header style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
				<Body>
					<Title>Add attachments</Title>
				</Body>
				<Right>
					<Button disabled={false} transparent onPress={close}>
						<Icon active name="checkmark" style={{ margin: 0 }} />
					</Button>
				</Right>
			</Header>
			{
				//add some notes from https://www.gov.uk/hmrc-internal-manuals/self-assessment-manual/sam126040
			}
			<Content padder>
				<H3>Currently attached</H3>
				<List>
					{attachments &&
						attachments.map((a, i) => (
							<ListItem thumbnail key={i}>
								<Left>
									<FontAwesome name="file-pdf-o" />
								</Left>
								<Body>
									<Text>{a.name}</Text>
									<Text note numberOfLines={1}>
										{a.hsize}
									</Text>
								</Body>
								<Right>
									<Button danger transparent onPress={() => removeAttachment(a.id)}>
										<Text>Remove</Text>
									</Button>
								</Right>
							</ListItem>
						))}
				</List>
				{attachments.length == 0 && <Text note>No attachments</Text>}
				<View padder />
				<Button primary bordered iconLeft onPress={addAttachment}>
					<Icon name="ios-add-circle-outline" />
					<Text>Add attachments</Text>
				</Button>
			</Content>
		</Container>
	);
}
